'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * src/reducers/flattenContent.js
 * Author: H.Alper Tuna <halpertuna@gmail.com>
 * Date: 17.09.2016
 */

/* eslint no-param-reassign: ["error", { "props": false }] */

var uid = void 0;
var flattenLevel = function flattenLevel(content, parentId) {
  var flatContent = [];
  content.forEach(function (item) {
    var id = item.id || uid;
    uid += 1;

    flatContent.push({
      id: id,
      parentId: item.parentId || parentId,
      icon: item.icon,
      label: item.label,
      to: item.to,
      externalLink: item.externalLink,
      active: false,
      hasActiveChild: false,
      subMenuVisibility: false
    });
    if (typeof item.content !== 'undefined') {
      flatContent = [].concat(_toConsumableArray(flatContent), _toConsumableArray(flattenLevel(item.content, id)));
    }
  });
  return flatContent;
};

var trace = void 0;
var mapTrace = function mapTrace(content, parentId) {
  var subItems = content.filter(function (item) {
    return item.parentId === parentId;
  });
  subItems.forEach(function (item) {
    item.trace = [].concat(_toConsumableArray(trace));
    trace.push(item.id);
    item.hasSubMenu = mapTrace(content, item.id);
    if (item.hasSubMenu) {
      item.to = '#';
    }
    trace.pop();
  });
  return subItems.length > 0;
};

exports.default = function (content) {
  uid = 1;
  trace = [];
  var flatContent = flattenLevel(content);
  mapTrace(flatContent);
  return flatContent;
};